import { ReactNode } from "react";

import TableCellGroup from "ds/components/Table/Row/CellGroup";
import { StackPullRequestItem } from "shared/Stack/useStackPullRequests/gql";

import { getStackPullRequestsTableExpandedRowKey } from "../helpers";
import useStackPullRequestsTableExpandedRowsStore from "../useExpandedRowsStore";

type StackPullRequestsTablePullRequestGroupToggleProps = {
  pullRequest: StackPullRequestItem;
  stackId: string;
  children: ReactNode;
};

const StackPullRequestsTablePullRequestGroupToggle = ({
  pullRequest,
  stackId,
  children,
}: StackPullRequestsTablePullRequestGroupToggleProps) => {
  const rowKey = getStackPullRequestsTableExpandedRowKey(stackId, pullRequest.id);

  const isExpanded = useStackPullRequestsTableExpandedRowsStore((state) =>
    state.expandedRows.has(rowKey)
  );
  const toggleRow = useStackPullRequestsTableExpandedRowsStore((state) => state.toggleRow);

  return (
    <TableCellGroup
      isActive
      isGroupOpen={isExpanded}
      onPress={() => toggleRow(rowKey)}
      title={`Toggle ${pullRequest.title} runs`}
    >
      {children}
    </TableCellGroup>
  );
};

export default StackPullRequestsTablePullRequestGroupToggle;
